/**
 * Stable error codes and the result envelope every package returns errors
 * through. Lives here because trace-ir is already the package "shared by
 * every downstream package" (see the package description) and these
 * conventions have no domain of their own.
 */
import { z } from "zod";
/**
 * Every failure mode a pipeline stage can report. Codes are additive and
 * never renumbered or removed once shipped, because receipts and CI logs
 * reference them by name.
 */
export const ERROR_CODES = [
    "SCHEMA_VALIDATION",
    "PATH_POLICY_VIOLATION",
    "BASELINE_NOT_REPRODUCED",
    "EXECUTION_TIMEOUT",
    "PROCESS_NONZERO_EXIT",
    "TOOLCHAIN_MISMATCH",
    "ARTIFACT_MISSING",
    "ARTIFACT_TAMPERED",
    "GATE_INCONCLUSIVE",
    "ALIGNMENT_AMBIGUOUS",
    "INTERNAL",
];
export const ErrorCodeSchema = z.enum(ERROR_CODES);
export const ErrorDetailSchema = z.object({
    code: ErrorCodeSchema,
    message: z.string().min(1),
    details: z.unknown().optional(),
});
/**
 * `{ ok: true, value }` on success or `{ ok: false, error }` on failure.
 * Every package that can fail returns this shape instead of throwing across
 * a package boundary, so callers branch on `ok` rather than catching.
 */
export function resultSchema(value) {
    return z.discriminatedUnion("ok", [
        z.object({ ok: z.literal(true), value }),
        z.object({ ok: z.literal(false), error: ErrorDetailSchema }),
    ]);
}
export function ok(value) {
    return { ok: true, value };
}
export function err(code, message, details) {
    return { ok: false, error: { code, message, details } };
}
//# sourceMappingURL=errors.js.map